const isProduction = process.env.NODE_ENV === 'production';

export const BASE_URL = isProduction
  ? 'https://steamreviewrandomizer.onrender.com'
  : 'http://localhost:5000';
